import React,{useEffect, useState} from 'react'
import { profileSettingStyles } from '../../../../styles/materialComponent';
import {Grid, Typography, IconButton, TableContainer, Table, TableHead, TableBody, TableRow, TableCell} from "@mui/material"
import CommonTable from "../../../common/table"
import EditIcon from '@mui/icons-material/Edit';
import { CssTextField } from '../../../../styles/materialComponent';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAllTrees } from '../../../../actions/tree';

const treeDetail=[
    "DBH",
    "Species",
    "Recomendation",
    "Tree Image",
    "Actions"
]
const GenerateReport = (props) => {  
    const {formik,setIsFormValid,isFormValid, setActiveStep,setEditClick} = props
    const dispatch = useDispatch()
      const classes = profileSettingStyles()
      const {reports} = useSelector(({report})=> report)
      const {trees, reportTrees} = useSelector(({tree})=> tree)

      useEffect(()=>{
        reports?._id && dispatch(fetchAllTrees(reports?._id))
      },[reports?._id])

      const data = {
        treeLat:formik.values.treeLat,
        treeLong:formik.values.treeLong,
        treeAddress:formik.values.treeAddress,
        treeImage:formik.values.treeImage?.length,
        treeMapImage:formik.values.treeMapImage,
        species:formik.values.species,
        treeHeight:formik.values.treeHeight,
        healthRating:formik.values.healthRating,
        hardscapedamage:formik.values.hardscapedamage,
        level:formik.values.level,
        treeDistance:formik.values.treeDistance,
        heritageTree:formik.values.heritageTree,
        observations:formik.values.observations,
        jurisdiction:formik.values.jurisdiction,
        secondaryReport:formik.values.secondaryReport,
        diseasePresent:formik.values.diseasePresent,
        recomendation:formik.values.recomendation,
      }
    
     console.log("das", data)
    useEffect(()=>{
        if(Object.values(data).some((value) => value === "" || value===undefined || value==="null" || value==="My Observation for this tree is")){
            setIsFormValid(true)
        }else{
            setIsFormValid(false)
        }
    },[formik.values])
   
    return (
      <>
        <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>         
         <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
         <Typography variant="h4" style={{display:"flex", justifyContent: "center"}}>Your Report so far...</Typography>
         </Grid>
        
            {
            reports?._id && 
            <>         
            <Grid item xs={12} sm={12} md={4} lg={4} className={classes.grid} >
            <CssTextField        
                // className={classes.textField1}
                required
                variant="outlined"
                autocomplete="off"
                style={{width:"80%"}}
                disabled={true}
                label="Report Name"    
                name="reportName" 
                value={formik.values.reportName}
            />
             <IconButton onClick={()=> setActiveStep(0)}>
                <EditIcon />
                </IconButton>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} className={classes.grid}>
              <CssTextField        
                // className={classes.textField1}
                required
                variant="outlined"
                autocomplete="off"
                style={{width:"80%"}}
                disabled={true}
                label="Client"    
                name="client" 
                value={formik.values.client?.clientName}
            />
             <IconButton onClick={()=> setActiveStep(1)}>
                <EditIcon />
                </IconButton>
            </Grid> 
            <Grid item xs={12} sm={12} md={4} lg={4} className={classes.grid}>
              <CssTextField        
                // className={classes.textField1}
                required
                variant="outlined"
                autocomplete="off"
                style={{width:"80%"}}
                disabled={true}
                label="Property"    
                name="property" 
                value={formik.values.property?.propertyName}
            />
             <IconButton onClick={()=> setActiveStep(2)}>
                <EditIcon />
                </IconButton>
            </Grid> 
            </>  
            }               
            {
                (trees?._id || (reportTrees && reports?._id) ) && 
                <>
                <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
                  <CommonTable lable="generateReport" tableCols={treeDetail} tableRows={reportTrees} setEditClick={setEditClick} setActiveStep={setActiveStep}/>
                </Grid>
             </>
            }
        </Grid> 
            </> 
    )
  }
  

export default GenerateReport